<fieldset>
  <legend>
    TypeFournitures
  </legend>
  <app-form-input  [label]="'locationVente'"
                  [name]="getUid()+'_SepAtt_locationVente'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeFournitures.locationVente">
  </app-form-input>

  <app-form-input  [label]="'achat'" [name]="getUid()+'_SepAtt_achat'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeFournitures.achat">
  </app-form-input>

  <app-form-input  [label]="'location'" [name]="getUid()+'_SepAtt_location'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeFournitures.location">
  </app-form-input>

  <app-form-input  [label]="'creditBail'" [name]="getUid()+'_SepAtt_creditBail'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeFournitures.creditBail">
  </app-form-input>
</fieldset>
